'use strict';

import './cancel_membership_modal.css';

import template from './cancel_membership_modal.html';

export default {
  bindings: {
    done: '&',
    decline: '&',
    reasons: '<',
  },
  template,
  controller ($scope, membership) {
    'ngInject';

    this.$onInit = () => {
      this.membership = membership;

      // code for some selected
      $scope.formReasons = $scope.formReasons || {};
      for (let prop in this.reasons) {
        $scope.formReasons[prop.value] = false;
      }
      let calculateSomeSelected = function () {
        $scope.someSelected = Object.keys($scope.formReasons).some(function(key) {
          return $scope.formReasons[key];
        });

        return $scope.someSelected;
      };
      $scope.checkboxChanged = calculateSomeSelected;
      $scope.someSelected = true;
    };

    this.unsubscribe = () => {
      this.loading = true;
      this.membership.cancelSubscription($scope.formReasons, this.message).then(() => {
        this.done();
      });
    };

  }
};



// WEBPACK FOOTER //
// ./app/src/modules/membership/cancel_membership/cancel_membership_modal.js